module.exports = {
	meta:{
		keyWords:'CTExcel，中國電信，香港電信，香港儲值卡，香港手機卡，香港旅遊，香港留學，香港流量，香港簽證，學生套餐，免費領卡，學生卡，體驗卡',
		description:'中國電信CTExcel赴港留學生專享優惠活動，是針對為在香港留學生提供優質的移動通訊服務，新用戶可免費領卡體驗。CTExcel所擁有的大專生專屬及高速本地流動通訊計劃等特色業務將使您的在香港生活更加便捷美好。',
	},
	index: {
		right: {//右侧悬浮框
			phone: '激活',
			order: '物流<br/>查詢',
			share: '分享',
			weibo: '微博',
			weChat: '微信',
			facebook: 'Facebook',
			copy: '複製',
			shareList:{
				weiChatText:'掃描二維碼，分享優惠活動'
			}
		},
		getNewCard:{
			phoneCard:'手機卡',
			phoneDate1:'香港高速數據',
			phoneDate2:'中國內地數據',
			phoneTalk:'香港本地或IDD致電內地',
			freeCard1:'我還沒有SIM卡',
			freeCard2:'免費領取手機卡',
			orderPkg1:'我已經領取SIM卡',
			orderPkg2:'購優惠套餐',
		},
		toCardInfo:"查看體驗卡詳情 >",
		advantage:{
			h3: '我們的優勢',
			title:'更多精彩',
			linkText: '查看香港數據及語言儲值卡2018體驗卡詳情',
			tipList:[
				{text:"CTExcel 4G LTE信號已覆蓋全港，高速穩定。通話信號強勁，語音音質清晰，不掉線不串線。"},
				{text:"AlipayHK APP、微信香港錢包一鍵充值繳費，支付寳、銀聯、Visa/Master、PayPal多種在綫支付方式便利生活"},
				{text:"面向不同的適用人群，如學生、商旅人士和旅遊者，CTExcel提供多款貼合用戶使用習慣的套餐服務。套餐同時分為合約制和非合約制，滿足用戶長短期的使用需求。"},
				{text:"我們的客服人員可使用普通話、粵語和英語三種語言與您交流，快速解答您的疑問。"}
			],
			advantageList:[
				{listText:'4G覆蓋'},
				{listText:'靈活支付'},
				{listText:'個性套餐'},
				{listText:'三語客服'}
			],
			msgList: [
				{top: '福利',tip1: '憑CTExcel電話號碼登記',tip2: 'AlipayHK領取新生大禮',tip3: '“港版支付寳”迎新禮'},
				{top: '特惠',tip1: '學生體驗卡專享',tip2: '大流量服務組合',list: ['免簽約','免住址證明','大流量隨心用']},
				{top: '超值',tip1: '可轉換大專生月費計劃',list: ['· 每月<span style="color: #ff861e;font-weight: 700;">免行政费 HK$18</span>','· 每月<span style="color: #ff861e;font-weight: 700;">送一日</span>中國內地數據漫遊 ','· 每月<span style="color: #ff861e;font-weight: 700;">送100分鐘</span>致電內地IDD']},
				{top: '賞你賞他推薦碼',tip1: '推薦一位朋友成功上台，即<span style="color: #ff861e;font-weight:700;">「賞」12GB數據!</span> 「賞」你6GB，「賞」他6GB!'}
			],
		},
		strategyStep:{
			title:'活動參與攻略',
			tip:'輕輕鬆鬆，三步搞定',
			stepList:[
				{name:"學生專享 $0電話卡",btntext:"免費領卡",url:"#/fillInfo",class:""},
				{name:"電話卡寄送到家直達手中",btntext:"激活手機卡",url:"https://dev.ctexcel.com.hk/ctghk/toActivate",class:""},
				{name:"免費領卡贈送的套餐，已經用完啦",btntext:"購優惠套餐",url:"#/pkgList",class:""},
			],
		}
	},
	footer: '*活動最終解釋權歸中國電信國際有限公司所有',
	btn: {
		next: '下一步',
		sure: '確定',
		pay: '立即支付',
		order: '立即搶購',
		act_back: '返回活動首頁 >',
		return_last: '返回上一步',
		receive: '立即領取',
		trans: '立即轉換',
		active: '去激活',
	},
	countrys: {
		china: '中國大陸',
		hk: '香港特別行政區',
	},
	//赏你赏他弹窗内容
	awardInfo: {
		title: '大專生賞你賞他',
		title_tip1: '「大專生賞你賞他」推薦計劃',
		tip1: '現有客戶推薦一比特朋友成功上臺，即「賞」12GB數據！「賞」你6GB，同時「賞」他6GB！推薦人（現有客戶）：賞6GB香港本地數據，「被推薦人」（新客戶）：賞6GB香港本地數據',
		title_tip2: '活動詳情',
		tip2: '「大專生本地」計劃–羽量級2018/羽量級2018/重量級2018之現有客戶（「推薦人」）於推廣期內推薦客戶透過開新號碼/攜號轉檯（「被推薦人」）成功申請「大專生本地」計劃–羽量級2018/羽量級2018/重量級2018及輸入專屬推薦碼（「推薦碼」），「推薦人」及「被推薦人」均可於合約期內第7至第12個月連續6個月，免費獲贈每月1GB額外香港本地數據（即每人合共獲贈6GB）。「推薦人」可將「大專生本地」計劃–羽量級2018/羽量級2018/重量級2018「確認電郵」內之「推薦碼」給予符合資格之「被推薦人」。',
		time: '活動推廣期由即日起至2019年6月30日',
		title_tip3: '「大專生賞你賞他」推薦計劃之條款及細則:',
		tip3: [
			{label:'1）「大專生賞你賞他」推薦計劃（「推薦計劃」）只適用於「大專生本地」計劃–羽量級2018/輕量級2018/重量級2018，「推薦人」及「被推薦人」不能為同一人。'},
			{label:'2）「被推薦人」成功登記服務後，「推薦人」及「被推薦人」均可於合約期內第7至第12個月連續6個月，免費獲贈每月1GB額外香港本地數據(即每人合共獲贈6GB)。',child_list: ['i)	「推薦人」及「被推薦人」免費獲贈每月1GB之額外香港本地數據不可累積使用。由於「推薦人」可於推廣期內獲得最多5個推薦名額，如成功推薦5位「被推薦人」，則每月最多可享免費5GB之額外香港本地數據，','ii)	若有任何剩餘免費獲贈之香港本地數據，將於當月底23:59自動取消，恕不另行通知。']},
			{label:'3）「推薦人」必須為「大專生本地」計劃–羽量級2018/輕量級2018/重量級2018之現有客戶，「被推薦人」必須於推廣期內透過開新號碼/攜號轉台成功申請「大專生本地」計劃–羽量級2018/輕量級2018/重量級2018(合約期12個月)及輸入專屬推薦碼（「推薦碼」）。'},
			{label:'4）「推薦人」及「被推薦人」須符合之要求：', child_list: ['i)	已登記選用「大專生本地」計劃–羽量級2018/輕量級2018/重量級2018；','ii)	流動通訊服務計劃仍然生效;','iii)	「推薦人」必須為「中國電信CTExcel」現有客戶（不適用於企業客戶）。','iv)	「推薦人」必須於活動推廣期內及於「被推薦人」申請及遞交指定服務計劃合約前，發送其專屬推薦碼（「推薦碼」）予「被推薦人」。','v)	「被推薦人」以香港身份證或有效之護照登記選用指定服務計劃及簽署期限合約。','vi)	「被推薦人」選用指定服務計劃時必須輸入由「推薦人」提供之有效「推薦碼」。','vii)	「被推薦人」之賬戶於服務計劃生效日起計100日後仍維持生效及無拖欠任何賬項紀錄。']},
			{label:'5）「推薦計劃」推廣期由2018年7月20日至2019年6月30日，包括首尾兩天。 '},
			{label:'6）「推薦人」可於推廣期內獲得最多5個推薦名額。「被推薦人」成功透過開新號碼/攜號轉台選購指定月費時，有關推薦名額會即時被扣除。'},
			{label:'7）若「被推薦人」於合约期内终止合约，則無法繼續享用此優惠，且需要按照合約上的規定賠償有關款項；而「推薦人」不會售到任何影響。'},
			{label:'8）所有推薦獎賞不可轉讓他人、退回、轉換或兌換為現金。'},
			{label:'9）欲查詢「推薦計劃」之詳情及優惠，請登入「中國電信CTExcel」官方網站<a href="www.ctexcel.com.hk">www.ctexcel.com.hk</a> 之活動頁面或致電24小時客戶服務熱線（+852）5749 9868。'},
			{label:'10）除特別注明外，上述月費優惠不可與其他推廣優惠同時使用。'},
			{label:'11）如有合理懷疑「推薦人」以非法、詐騙或其他不良手法推薦上台，「中國電信CTExcel」將有權取消「推薦人」參加本「推薦計劃」的資格。'},
			{label:'12）「中國電信CTExcel」保留隨時更改、更新或終止所有優惠，以及修訂所述任何條款及細則之權利，而不予事先通知。如有任何爭議，「中國電信CTExcel」保留最終決定權。'},
		],
	},
	fillInfo: {
		title_per: '填寫個人信息',
		title_send: '填寫收貨地址',
		user_cname: '中文姓名',
		user_ename: '英文姓名（選填）',
		email: '郵箱',
		school_name: '學校名稱',
		code: '活動推薦碼',
		codeDes:[
			'獎勵是什麼？',
			'填寫推薦碼，并成功轉換為校園棒棒糖2019計劃（少糖級/半糖級/全糖級/少糖級之早鳥/半糖級之早鳥/全糖級之早鳥任一個），雙方均可獲得6GB流量（合約期內第7至第12個月連續6個月，免費獲贈每月1GB額外香港本地數據）；',
			'如何獲得？',
			'購買/轉換校園棒棒糖2019計劃（少糖級/半糖級/全糖級/少糖級之早鳥/半糖級之早鳥/全糖級之早鳥任一個）即可獲得推薦碼。',
		],
		reach_date: '預計赴港日期（選填）',
		phone: '聯繫電話',
		send_address: '寄送地區',
		address: '詳細地址',
		rules: {
			user_cname1: '請填寫您的中文姓名',
			user_cname2: '請輸入中文字符',
			user_ename: '請輸入英文字符',
			school_name: '請選擇就讀學校',
			email1: '請填寫您的郵箱',
			email2: '請輸入正確的郵箱以便查收確認郵件',
			code: '您填寫的推薦碼格式不對',
			file_name: '請上傳學生錄取通知書',
			phone1: '請填寫聯繫電話',
			phone2: '請輸入正確的聯繫電話',
			zone1: '請選擇省',
			zone2: '請選擇區域',
			district1: '請選擇市',
			district2: '請選擇區',
			area: '請選擇縣',
			address1: '請填寫您的詳細地址',
			address2: '請填寫正確的室、樓、住宅名稱（不允許填寫特殊字符）',
		},
		checkboxs: {
			one: '本人同意貴公司使用本人的個人資料作直接促銷用途，并希望接受任何推廣及直接促銷通訊',
			two: '我同意并接受服務條款的所有內容'
		},
		pop: {
			title: '信息確認',
			title_per: '個人信息',
			title_send: '收貨地址',
		},
		imgTip: '請務必提供真實有效的相關證件，以免審核不通過耽誤您的使用。',
		service_rule: [//服务条款
			'1、 「校園棒棒糖推廣活動」 一 免費中國電信CTExcel「香港數據及話音儲值卡2019體驗版」優惠(「校園棒棒糖推廣活動」)之登記期由即日起至2019年12月31日，包括首尾兩日，名額有限，額滿即止。',
			'2、 「校園棒棒糖推廣活動」只適用於指定及持有香港可頒授學位的高等教育院校所發出之錄取通知書(「錄取通知書」)之學生。',
			'3、 免費中國電信CTExcel「香港數據及話音儲值卡2019體驗版」之申請及啟動方法:<ul><li>i) 如客戶通過「寄託網」或指定之高校學生團體獲取中國電信CTExcel「香港數據及話音儲值卡2019體驗版」，有關客戶身份認證及SIM卡物流運送之事宜，詳情請諮詢「寄託網」或指定之高校學生團體。當用戶收到SIM卡後，必須於中國電信CTExcel官方網站(www.ctexcel.com.hk )之「校園棒棒糖推廣活動」頁面輸入SIM卡之ICCID及所需之個人資料進行SIM卡啟動，成功啟動後會收到「確認啟動」之電郵。</li><li>ii) 如客戶通過中國電信CTExcel官方網站直接登記申請獲取免費中國電信CTExcel「香港數據及話音儲值卡2019體驗版」，用戶需要填寫指定之個人資料，提供有效之「錄取通知書」副本作爲憑證，成功提交後，經內部確認核實資料無訛，方可獲取「香港數據及話音儲值卡2019體驗版」一張。</li></ul>',
			'如用戶於2019年12月31日香港時間23時59分尚未進行SIM卡啟動，SIM卡將隨即自動失效，並視為主動放棄「校園棒棒糖推廣活動」。',
			'4、 每個有效「錄取通知書」只可以申請免費中國電信CTExcel「香港數據及話音儲值卡2019體驗版」1次。',
			'5、 以上優惠不可與其他優惠同時使用或兌換現金。',
			'6、 客戶亦同意遵守中國電信CTExcel「香港數據及話音儲值卡2019體驗版」之條款及細則。',
			'7、 中國電信國際有限公司(「中國電信國際」)有權更改相關之條款及細則，恕不另行通知，並有權更改或終止任何優惠。如有任何爭議，中國電信國際將保留一切最終決定權。'
		],
	},
	//领卡成功页面
	getCardSuccess: {
		top: {
			title: '您的手機卡領取申請已提交',
			order_id: '訂單號：',
			freight: '運費：',
			tip: '請耐心等待，確認結果將會已郵件形式通知給您，確認通過后手機卡將盡快寄送給您。',
		},
		attention: {
			tip1: '關注官方微信公眾號“中國電信CTExcelHK”，話費賬單輕鬆查，套餐用量實時看。',
			tip2: '如有任何疑問請致電服務熱線<br />24小時客服電話+852 5749 9868'
		},
		rules_title: '活動規則',
		rules: [
			'1、大專生推廣活動 一 免費中國電信CTExcel「香港數據及話音儲值卡2018體驗版」優惠(「大專生2018推廣活動」)之登記期由即日起至2018年9月30日，包括首尾兩日，名額有限，額滿即止',
			'2、「大專生2018推廣活動」只適用於指定及持有香港可頒授學位的高等教育院校所發出之錄取通知書(「錄取通知書」)之學生。',
			'3、免費中國電信CTExcel「香港數據及話音儲值卡2018體驗版」之申請及激活方法:',
			'<ul style="margin-left:20px;"><li>· 如客戶通過「寄托網」或指定之高校學生團體獲取中國電信CTExcel「香港數據及話音儲值卡2018體驗版」，有關客戶身份認證及SIM卡物流運送之事宜，詳情請諮詢「寄托網」或指定之高校學生團體。當用戶收到SIM卡後，必須於中國電信CTExcel官方網站(<a href="https://www.ctexcel.com.hk">www.ctexcel.com.hk</a>)之「大專生2018推廣活動」頁面輸入SIM卡之ICCID及所需之個人資料進行SIM卡激活，成功激活後會收到「確認啟動」之電郵。</li><li>· 如客戶通過中國電信CTExcel官方網站直接登記申請獲取免費中國電信CTExcel「香港數據及話音儲值卡2018體驗版」，用戶需要填寫指定之個人資料，提供有效之「錄取通知書」副本作爲憑證，成功提交後，經內部確認核實資料無訛，方可獲取「香港數據及話音儲值卡2018體驗版」一張。<br/>如用戶於2018年9月30日香港時間23時59分尚未進行SIM卡激活，SIM卡將隨即自動失效，並視為主動放棄「大專生2018推廣活動」。</li></ul>',
			'4、每個有效「錄取通知書」只可以申請免費中國電信CTExcel「香港數據及話音儲值卡2018體驗版」1次。',
			'5、以上優惠不可與其他優惠同時使用或兌換現金。',
			'6、客戶亦同意遵守中國電信CTExcel「香港數據及話音儲值卡2018體驗版」之條款及細則。',
			'7、中國電信國際有限公司(「中國電信國際」)有權更改相關之條款及細則，恕不另行通知，並有權更改或終止任何優惠。如有任何爭議，中國電信國際將保留一切最終決定權。'
		],
		pkg_title: '還差一步，就可領取到優惠大流量服務組合！',
		listTip: '溫馨提示：以上大流量服務組合可以疊加購買',
	},
	//支付确认页面
	pay: {
		title: '請選擇支付方式',
	},
	//支付结果页面
	payResult: {
		suc: {
			title: '恭喜您，訂購成功',
			order_id: '訂單號：',
			auth_code: '認證碼：',
			pkgName: '套餐名稱：',
			amount: '支付金額：',
			act_title: '激活攻略',
			tips: [
				'關注官方微信公眾號',
				'“中國電信CTExcelHK”',
				'話費賬單輕鬆查，套餐用量實時看',
				'如有任何疑問請致電服務熱線',
				'24小時客服電話+852 5749 9868'
			]
		},
		fail: {
			title: '支付失敗',
			tips: [
				'如不是以上原因，請致電服務熱線',
				'24小時客服電話+852 5749 9868'
			]
		}
	},
	//输入iccid
	inputIccid: {
		rules: {
			iccid1:'請填寫ICCID',
			iccid2:'請輸入正確的19位數字，不包含F',
		},
		errMsg: {
			code1: 'iccid不存在，請重新輸入',
			code2: 'iccid不在活動範圍',
			code3: '用戶未激活，請先去官網激活',
			code5: '失敗（其他），請重新輸入',
		}
	},
	//套餐列表页
	pkgList: {
		title: '大流量服務組合',
		title_tip: '免簽約  ·  免住址證明  ·  大流量隨心用',
		top_tip: '還沒手機卡？點擊這裡',
		tranPkg: {
			title: '轉換月費計劃',
			title_tip: '先使用，後付帳，套餐種類更齊全！',
			top: '什麼是月費計劃？',
			top_ans: '月費計劃即月付通訊套餐',
		},
		stuTip1: '每月$18行政費',
		stuTip2: '每月贈送HK$18 特惠IDD致電中國內地100分鐘',
		stuTip3: '每月贈送1日中國內地「數據漫遊Day Pass」（價值：HK$576）',
		period: '合約期',
		
	},
}


// WEBPACK FOOTER //
// ./src/common/lang/hk.js